var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.259 18.4538C23.0896 16.69 24.9933 13.5763 24.9933 10C24.9933 4.48625 20.5101 0 15 0C9.48992 0 5.00666 4.48625 5.00666 10C5.00666 13.5725 6.89915 16.6963 9.72352 18.465C4.74309 20.3038 0.980596 24.6563 0 30H2.54705C3.81746 24.2875 8.91406 20 15 20C21.0859 20 26.1825 24.2875 27.4529 30H30C29.0169 24.65 25.2494 20.29 20.259 18.4538ZM7.505 10C7.505 5.86375 10.8665 2.5 15 2.5C19.1322 2.5 22.495 5.86375 22.495 10C22.495 14.1363 19.1322 17.5 15 17.5C10.8665 17.5 7.505 14.1363 7.505 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.74314e5a164066d17c633895fac1e2c5.svg";
export { ForwardRef as ReactComponent };